import { NavigationProductsApplications } from '../../models/navigation-products-applications.enum';

export const productsIconsMap = new Map([
  [NavigationProductsApplications.Academy, 'building'],
  [NavigationProductsApplications.Analytics, 'trend'],
  [NavigationProductsApplications.Benefits, 'star'],
  [NavigationProductsApplications.External, 'link'],
  [NavigationProductsApplications.HR, 'users'],
  [NavigationProductsApplications.LMS, 'student-hat'],
  [NavigationProductsApplications.MyPay, 'money'],
  [NavigationProductsApplications.Onboarding, 'home-alt'],
  [NavigationProductsApplications.Payroll, 'money'],
  [NavigationProductsApplications.Recruitment, 'user-magnifier'],
  [NavigationProductsApplications.Settings, 'cog'],
]);
